module.exports = __webpack_public_path__ + "static/media/25_B.3ded577a.png";